// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"survey-loading_wrapper__111-2","rotate":"survey-loading_rotate__L4pIX"};